// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-slides {
  height: 100%;
}

.swiper-slide {
  display: block;
}

.swiper-slide h2 {
  margin-top: 1.2rem;
}

.swiper-slide img {
  max-height: 30%;
  max-width: 30%;
  margin: 60px 0 0;
  pointer-events: none;
}

b {
  font-weight: 500;
}

p {
  padding: 0 40px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ion-color-step-600, #60646b);
}

p b {
  color: var(--ion-text-color, #000000);
}

.padding1 {
  padding: 0.5rem;
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.text-button {
  color: var(--ion-color-primary);
  cursor: pointer;
}

ion-slides {
  --bullet-background: var(--ion-color-medium);
  --bullet-background-active: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/popup/help-slide/help-slide.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AACF;;AAEA;EACE,+BAAA;EACA,eAAA;AACF;;AAEA;EACE,4CAAA;EACA,oDAAA;AACF","sourcesContent":["ion-slides {\n  height: 100%;\n}\n\n.swiper-slide {\n  display: block;\n}\n\n.swiper-slide h2 {\n  margin-top: 1.2rem;\n}\n\n.swiper-slide img {\n  max-height: 30%;\n  max-width: 30%;\n  margin: 60px 0 0;\n  pointer-events: none;\n}\n\nb {\n  font-weight: 500;\n}\n\np {\n  padding: 0 40px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--ion-color-step-600, #60646b);\n}\n\np b {\n  color: var(--ion-text-color, #000000);\n}\n\n.padding1 {\n  padding: 0.5rem;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n.text-button {\n  color: var(--ion-color-primary);\n  cursor: pointer;\n}\n\nion-slides {\n  --bullet-background: var(--ion-color-medium);\n  --bullet-background-active: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
